//
// duplicate the fields on the click of the "Add Income" button
//

var duplicateIncomeSection = (function () {
    'use strict';

    var addPrimaryIncomeAccountButton = $('#add_primary_income');
    var addSecondaryIncomeAccountButton = $('#add_secondary_income');

    var primaryIncomeContainer = document.querySelectorAll(".income_container");
    var primaryIncomeTemplate = $("#primary-income-form-template");
    var primaryHBSIncomeTemplateId = 'primary-income-form-handlebars-template';

    var secondaryIncomeContainer = document.querySelectorAll(".co_borrower_income_container");
    var secondaryIncomeTemplate = $("#secondary-income-form-template");
    var secondaryHBSIncomeTemplateId = 'secondary-income-form-handlebars-template';

    var removeButton = ".remove-income-button";

    var incomeTypeSelect = "select[name='income_type']";

    var customCounter = 0;
    var expanderCounter = 1;
    var idsDict = {};

    var availableIncomeTypes = [];
    var initialIncomeTypes = [];

    function checkAndAdjustAttr(attrName, element) {
        if (element.attr(attrName)) {
            var val = element.attr(attrName);

            if (!idsDict[val]) {
                var attrValue = `${val}-custom-${customCounter}`;
                if (attrName == 'aria-describedby') {
                    attrValue += ' dropdown-instructions'; 
                }
                idsDict[val] = attrValue;
                customCounter++;

            }

            element.attr(attrName, idsDict[val]);
        }
    }

    function fixAttributes(fieldsClone) {
        var elements = [];
        idsDict = {};

        elements.push(fieldsClone);

        // go trough element and it's children using a BFS-like traversal
        while (elements.length) {
            var curr = elements.pop();

            var toCheck = ["id", "data-id", "for", "aria-owns", "aria-describedby"];
            for (var attrId in toCheck) {
                checkAndAdjustAttr(toCheck[attrId], $(curr));
            }

            for (var child of $(curr).children().toArray()) {
                elements.push(child);
            }
        }
    }

    function fixExpanderAttributes(fieldsClone, container) {
        $(fieldsClone).find('#incomeCollapse').attr('id', 'incomeCollapse-' + expanderCounter);
        $(fieldsClone).find('#incomeHeading').attr('id', 'ofiHeading-' + expanderCounter);
        $(fieldsClone).find("[data-target='#incomeCollapse']").attr("data-target", "#incomeCollapse-" + expanderCounter);
        $(fieldsClone).find("[aria-controls='incomeCollapse']").attr("aria-controls", "incomeCollapse-" + expanderCounter);

        //without this expander items won't expand/collapse
        if (container.hasClass('primary_income_container')) {
            $(fieldsClone).find('.js-toggle').attr('data-parent', '#primary-income-expander');
        }
        else {
            $(fieldsClone).find('.js-toggle').attr('data-parent', '#secondary-income-expander');
        }
    }

    // when adding/removing a section the number of the sections header need to be updated.
    function fixHeaders(container) {
        container.find(".income-expander-item-header").each(function (index) {
            var text = $(this).text(),
                textTokens = text.split(' '),
                num = Number(textTokens[textTokens.length - 1]),
                newText = text.replace(num, ++index);

            //index starts from 0
            $(this).text(newText);

            $(this).closest(".card-header").find(".remove-income-button .sr-only").text(newText);
        });
    }

    function attachRemoveFunctionality(args, e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var element = $(e.currentTarget).closest('.income-expander-item');

        element.remove();

        fixHeaders(args[0]);
        //updateIncomeTypeDropdownValues();
    }

    function arrayRemove(arr, value) {
        return arr.filter(function (ele) { return ele != value; });
    }

    function updateAvailableIncomeTypes() {
        availableIncomeTypes = [...initialIncomeTypes];

        $(incomeTypeSelect).each(function (index) {
            if (index > 0) {
                var val = $(this).val();
                availableIncomeTypes = arrayRemove(availableIncomeTypes, val);
            }
        });
    }

    function removeUnwantedIncomeTypes() {
        $(`${incomeTypeSelect} option`).show();
        $(`${incomeTypeSelect} option`).each(function () {
            var option = $(this).val();

            if (initialIncomeTypes.includes(option) && !availableIncomeTypes.includes(option)) {
                $(this).hide();
            }
        });
    }

    function updateIncomeTypeDropdownValues(e) {
        updateAvailableIncomeTypes();
        removeUnwantedIncomeTypes();
    }

    function expandFirstItem(currentExpanderItem) {
        $(currentExpanderItem).find('.js-toggle').collapse('toggle');
    }

    function addIncome(container, template) {
        // true, true -> makes a deep copy of the children and copy the events
        template.children().first().find('[data-toggle="tooltip"]').tooltip('dispose');
        var fieldsClone = template.children().first().clone(true, true);
        var expanderContent = $(fieldsClone).find('.income-expander-item-content');

        $(fieldsClone).find('[data-toggle="tooltip"]').tooltip();

        fixAttributes(expanderContent);
        fixExpanderAttributes(fieldsClone, container);

        container.append(fieldsClone);

        expandFirstItem(fieldsClone);

        fixHeaders(container);
        $(".remove-income-button").last().focus();
        expanderCounter++;
    }

    function getIncomeTypes() {
        var select = $(incomeTypeSelect);
        select.children().each(function (index) {
            if (index != 0) {
                var type = $(this).val();
                availableIncomeTypes.push(type);
            }
        });

        initialIncomeTypes = [...availableIncomeTypes];
    }

    function appendFirstCloneToHBS(container, hbsIncomeTemplateId) {
        // true, true -> makes a deep copy of the children and copy the events
        var fieldsCloneInitial = $(container.children().first()).clone(true, true);

        //we don't want initial Income (should be wrapped in expander)
        $(container.children().first()).remove();

        var handlebarsHTML = document.getElementById(hbsIncomeTemplateId).innerHTML;
        var hbsTemplate = Handlebars.compile(handlebarsHTML);

        var contextObj = {
            expanderItemContent: fieldsCloneInitial.html()
        };

        var compiledData = hbsTemplate(contextObj);
        return compiledData;
    }

    function init(container, hbsIncomeTemplateId, template, addAnotherAccountButton) {
        getIncomeTypes();

        var compiledData = appendFirstCloneToHBS(container, hbsIncomeTemplateId);

        template.prepend(compiledData);

        //without this expander items won't expand/collapse
        if (container.hasClass('primary_income_container')) {
            container.attr('id', 'primary-income-expander');
        }
        else {
            container.attr('id', 'secondary-income-expander');
        }

        addAnotherAccountButton.click(function () { addIncome(container, template); });

        $(document).on('click', removeButton, attachRemoveFunctionality.bind(this, [container]));
    }


    if (primaryIncomeContainer.length) {
        init($(primaryIncomeContainer), primaryHBSIncomeTemplateId, primaryIncomeTemplate, addPrimaryIncomeAccountButton);
    }
    if (secondaryIncomeContainer.length) {
        init($(secondaryIncomeContainer), secondaryHBSIncomeTemplateId, secondaryIncomeTemplate, addSecondaryIncomeAccountButton);
    }
})();
